import React from 'react';
import {connect} from 'react-redux';
import {reduxForm, formValueSelector, change} from 'redux-form';

import {
  MODALS,
  fetchPermissionEntities,
  selectPermissionNamespacedEntities
} from 'ducks/teams';

import {selectModal} from 'ducks/modals';
import {selectLocations} from 'ducks/locations';

import {TeamPermissionsForm} from 'containers/MyTeams/components/shared';

import './styles.css';

class AddTeamPermissionsForm extends React.Component<any> {
  componentDidMount() {
    this.props.fetchPermissionEntities();
  }

  selectedLocations = () => {
    const {locations, selectedLocations} = this.props;

    return locations.filter(location => selectedLocations[location.ref]);
  };

  changePermissionField = ({id, value}) => {
    this.props.change(id, value);
  };

  render() {
    const {
      locationSpecific,
      generic,
      avatarUrl,
      name,
      selectedPermissions
    } = this.props;
    const locations = this.selectedLocations();

    const newTeam = {name, avatarUrl, locations, members: []};

    return (
      <TeamPermissionsForm
        team={newTeam}
        locationSpecific={locationSpecific}
        generic={generic}
        selectedPermissions={selectedPermissions}
        changePermissionField={this.changePermissionField}
      />
    );
  }
}

const formSelector = formValueSelector('addTeamPermissions');

const mapStateToProps = state => {
  const {avatarUrl, name, locations} = selectModal(state, MODALS.ADD_TEAM).data;
  const {locationSpecific, generic} = selectPermissionNamespacedEntities(state);

  return {
    avatarUrl,
    name,
    locationSpecific,
    generic,
    selectedLocations: locations || {},
    locations: selectLocations(state),
    selectedPermissions: formSelector(state, 'permissions')
  };
};

const mapDispatchToProps = {fetchPermissionEntities, change};

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({form: 'addTeamPermissions'})(AddTeamPermissionsForm)
);
